import {
  isApp,
  isMobile,
  newTriggerOneLink,
  WalletType,
} from '@web3/base-utils';
import { useHybirdWallet } from '@web3/base-hooks';
import { useCurrentWallet } from '@web3fe/infra';
import { useAppVersion } from '@/hooks/appVersion';

export const useConnectWallet = () => {
  const { openLoginModal, walletType } = useHybirdWallet();
  const { openAppVersionModal } = useAppVersion();
  const { switchToBybitExtension } = useCurrentWallet();

  const connectWallet = async () => {
    if (isMobile && !isApp()) {
      newTriggerOneLink(window.location.href);
      return;
    }

    if (isApp()) {
      const result = await openAppVersionModal();
      if (!result) {
        return;
      }
    }

    if (walletType !== WalletType.MNEMONIC_PHRASE) {
      switchToBybitExtension(WalletType.MNEMONIC_PHRASE);
      return;
    }

    openLoginModal();
  };

  return { connectWallet };
};
